interface IObj {
  [key: string]: string | undefined | Array<any>;
}

export const isNotEmptyObj = (obj: IObj) => Object.values(obj).some(value => Array.isArray(value) ? value.length : value)
